import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import GenerationBonusTable from "./Table/generationBonusTable";

const GenerationBonusPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="genrationbonus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Generation Bonus"
      table={<GenerationBonusTable />}
    />
  );
};

export default GenerationBonusPage;
